<div class="container h-100" *ngIf="isLoading" [@.disabled]="true">
  <div class="row h-100 justify-content-center align-items-center">
    <div class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div> 
</div>
<div (clickOutside)="onClickedOutside($event)" [@.disabled]="true" (click)="onClickedInside($event)"
  *ngIf="!isLoading">
  <nav class="navbar navbar-dark fixed-top" [ngClass]="{
      staging: isStaging == true && churchName.trim() != 'Church Services'
    }">
    <div [ngClass]="isFluid() ? 'container-fluid' : 'container'">
      <div style="width:47px" *ngIf="showMemberNavDiv"> 
        <i class="pointer fas fa-arrow-circle-left text-light fa-2x hcenter" (click)="goBack()"></i>
      </div>
      <div style="width:47px" *ngIf="globalService.isRTL == true && router.url !='/home' && (isHomeFlag == false)">
        <i class="pointer fas fa-arrow-circle-right text-light fa-2x hcenter" (click)="goBack()"></i>
      </div>
      <div class="churchNameClass hcenter" style="height:54px; max-height:54px;">
        <div class="navbar-brand dontselect slimbar no-margin churchNameClass hcenter">
          <span><img class="slimbar" *ngIf="isHome()" src="{{ logoSource }}" width="50" height="50" /></span>
          <div class="navbar-brand hcenter" *ngIf="isHome()">
            <div class="text-wrap hcenter" [class.longName]="globalService.isRTL == false"
              [class.longNameArabic]="globalService.isRTL == true" [class.mr-2]="globalService.isRTL == true"
              [class.ml-2]="globalService.isRTL == false" [class.ArabicFont]="globalService.isRTL == true"
              style="font-size:0.8em; max-width: 150px;">
              <span class="text-wrap">{{ churchName }}</span> 
            </div>
          </div>
          <div class="text-center churchNameClass hcenter"
            style="height:54px; max-height:54px; max-width: 150px;" *ngIf="isHome()==false">
            <div class="text-wrap text-center longName hcenter">
              <span class="text-center" style="font-size:0.8em">{{ showTitle() }} </span>
            </div>
          </div>
        </div>
      </div>
      <div class="pointer" style="height:50px; max-height:50px">
        <button class="navbar-toggler p-2" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
      <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse navbar-dark" id="navbarNav">
        <br />
        <div class="navbar-nav navbar-dark mr-auto">
          <ul class="navbar-nav ml-3 text-left">
            <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
              <a role="button" (click)="goFeatures()" class="nav-link" [class.text-left]="globalService.isRTL == false"
                [class.text-right]="globalService.isRTL == true"
                [class.SmallArabicFont]="globalService.isRTL == true">{{ globalService.Get("HOME") }}</a>
            </li>
            <li class="nav-item">
              <hr class="border-top" />
            </li>
            <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
              <a role="button" (click)="Features()" class="nav-link" [class.text-left]="globalService.isRTL == false"
                [class.text-right]="globalService.isRTL == true" [class.SmallArabicFont]="globalService.isRTL == true"
                *ngIf="identityService.authenticated">{{ globalService.Get("SYSTEM_MENU") }}</a>
            </li>
            <li class="nav-item" *ngIf="
                identityService.permissions != null &&
                identityService.permissions.indexOf('Check-in') >= 0
              " routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
              <a role="button" (click)="Usher()" class="nav-link" [class.text-left]="globalService.isRTL == false"
                [class.text-right]="globalService.isRTL == true" [class.SmallArabicFont]="globalService.isRTL == true"
                *ngIf="identityService.authenticated">{{ globalService.Get("CHECKIN") }}</a>
            </li>
            <li class="nav-item" *ngIf="identityService.authenticated">
              <hr class="border-top" />
            </li>
            <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
              <a role="button" class="nav-link" [class.text-left]="globalService.isRTL == false"
                (click)="setLanguage('English')" [class.text-right]="globalService.isRTL == true"
                [class.SmallArabicFont]="globalService.isRTL == true">English <i
                  *ngIf="globalService.currentLanguage == 'English'" class="fas fa-check text-light ml-2"></i></a>
            </li>
            <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
              <a role="button" class="nav-link" [class.text-left]="globalService.isRTL == false"
                (click)="setLanguage('Arabic')" [class.text-right]="globalService.isRTL == true"
                [class.SmallArabicFont]="globalService.isRTL == true">عربي <i
                  *ngIf="globalService.currentLanguage == 'Arabic'" class="fas fa-check text-light ml-2"></i></a>
            </li>
            <li class="nav-item" *ngIf="identityService.authenticated">
              <hr class="border-top" />
            </li>
            <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="
            identityService.permissions != null &&
            identityService.permissions.indexOf('Base') >= 0
          ">
              <a role="button" (click)="MyProfile()" class="nav-link" [class.text-left]="globalService.isRTL == false"
                [class.text-right]="globalService.isRTL == true" [class.SmallArabicFont]="globalService.isRTL == true"
                *ngIf="identityService.authenticated">{{ globalService.Get("PROFILE") }}</a>
            </li>

          </ul>
        </div>
        <div class="navbar-nav navbar-dark mr-auto" [ngClass]="{
            'ml-lg-auto mr-lg-0': identityService.authenticated,
            'ml-sm-auto mr-sm-0': !identityService.authenticated
          }">
          <ul class="navbar-nav ml-3 text-left">
            <li class="nav-item">
              <hr class="border-top" />
            </li>
            <li class="nav-item">
              <a role="button" (click)="ChangeChurch()" class="nav-link text-left text-light"
                [class.text-left]="globalService.isRTL == false" [class.text-right]="globalService.isRTL == true"
                [class.SmallArabicFont]="globalService.isRTL == true">{{ globalService.Get("CHANGE_CHURCH") }}</a>
            </li>
            <li class="nav-item">
              <hr class="border-top" />
            </li>
            <li class="nav-item">
              <a (click)="Login()" class="nav-link text-left" [class.text-left]="globalService.isRTL == false"
                [class.text-right]="globalService.isRTL == true" [class.SmallArabicFont]="globalService.isRTL == true"
                *ngIf="!identityService.authenticated">{{ globalService.Get("LOGIN") }}</a>
            </li>
            <li class="nav-item pl-1">
              <a class="nav-link pointer" [class.SmallArabicFont]="globalService.isRTL == true"
                [class.text-right]="globalService.isRTL == true" *ngIf="identityService.authenticated"
                (click)="OnLogout()">{{ globalService.currentFirstName }} -
                {{ globalService.Get("LOGOUT") }}
              </a>
            </li>
            <li class="nav-item text-right">
              <a href="https://church-services.com/privacy-policy/" target="_blank"
                (click)="isMenuCollapsed = true"><span class="tiny text-light">Privacy Policy</span></a>
            </li>
            <li class="nav-item text-right"> 
              <span class="tiny text-light">v26.043</span>
            </li>
          </ul> 
        </div>
      </div>
    </div>
  </nav> 
</div> 